const TICK_INTERVAL_MS = 250;

/** Lance le métronome (dans un Web Worker si possible) et renvoie de quoi l'arrêter. */
export function startClock(onTick: () => void): () => void {
  try {
    const worker = new Worker('metronome.worker.js');
    worker.onmessage = () => onTick();
    worker.postMessage({ type: 'start', interval: TICK_INTERVAL_MS });
    return () => worker.terminate();
  } catch {
    const timer = setInterval(onTick, TICK_INTERVAL_MS);
    return () => clearInterval(timer);
  }
}
